"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEntity;
function getEntity(keyEntities, key) {
  return keyEntities[key];
}